// Handles redirecting Shop dropdown toggle click to the configured shop URL
// so that the dropdown only opens on hover and click navigates directly.
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('shop-button-toggle');
  if (!toggle) return;

  // Use URL from data attribute (falls back to href if not present)
  const url = toggle.dataset.redirectUrl || toggle.getAttribute('href') || '#';

  toggle.addEventListener('click', (event) => {
    // Prevent Webflow dropdown JS from hijacking the click.
    event.stopPropagation();

    if (url && url !== '#') {
      window.location.href = url;
    }
  });
});
